
import { Prop, Vue, Component } from 'vue-property-decorator';

@Component({
    props: {
        link: String,
        text: String
    }
})
export default class BaseNavLink extends Vue {
    @Prop() readonly link!: string;
    @Prop() readonly text!: string;
}
